import * as Types from '../../../../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateImpactGroupMutationVariables = Types.Exact<{
  input: Types.CreateImpactGroupTemplateInput;
}>;


export type CreateImpactGroupMutation = (
  { __typename?: 'Mutation' }
  & { createImpactGroupTemplate?: Types.Maybe<(
    { __typename?: 'CreateImpactGroupTemplatePayload' }
    & { impactGroupTemplate?: Types.Maybe<(
      { __typename?: 'ImpactGroupTemplate' }
      & Pick<Types.ImpactGroupTemplate, 'rowId' | 'label' | 'slug' | 'description' | 'notificationMessage' | 'severity' | 'scope' | 'location' | 'active' | 'actionUrl' | 'createdBy' | 'updatedBy' | 'templateExpiresAt' | 'createdAt' | 'updatedAt'>
    )> }
  )> }
);

export type UpdateImpactGroupTemplateMutationVariables = Types.Exact<{
  rowId: Types.Scalars['Int']['input'];
  patch: Types.ImpactGroupTemplatePatch;
}>;


export type UpdateImpactGroupTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateImpactGroupTemplate?: Types.Maybe<(
    { __typename?: 'UpdateImpactGroupTemplatePayload' }
    & { impactGroupTemplate?: Types.Maybe<(
      { __typename?: 'ImpactGroupTemplate' }
      & Pick<Types.ImpactGroupTemplate, 'rowId' | 'label' | 'slug' | 'description' | 'notificationMessage' | 'severity' | 'scope' | 'location' | 'active' | 'actionUrl' | 'createdBy' | 'updatedBy' | 'templateExpiresAt' | 'createdAt' | 'updatedAt'>
    )> }
  )> }
);


export const CreateImpactGroupDocument = gql`
    mutation CreateImpactGroup($input: CreateImpactGroupTemplateInput!) {
  createImpactGroupTemplate(input: $input) {
    impactGroupTemplate {
      rowId
      label
      slug
      description
      notificationMessage
      severity
      scope
      location
      active
      actionUrl
      createdBy
      updatedBy
      templateExpiresAt
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateImpactGroupMutationFn = Apollo.MutationFunction<CreateImpactGroupMutation, CreateImpactGroupMutationVariables>;

/**
 * __useCreateImpactGroupMutation__
 *
 * To run a mutation, you first call `useCreateImpactGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImpactGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImpactGroupMutation, { data, loading, error }] = useCreateImpactGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImpactGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateImpactGroupMutation, CreateImpactGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImpactGroupMutation, CreateImpactGroupMutationVariables>(CreateImpactGroupDocument, options);
      }
export type CreateImpactGroupMutationHookResult = ReturnType<typeof useCreateImpactGroupMutation>;
export type CreateImpactGroupMutationResult = Apollo.MutationResult<CreateImpactGroupMutation>;
export type CreateImpactGroupMutationOptions = Apollo.BaseMutationOptions<CreateImpactGroupMutation, CreateImpactGroupMutationVariables>;
export const UpdateImpactGroupTemplateDocument = gql`
    mutation UpdateImpactGroupTemplate($rowId: Int!, $patch: ImpactGroupTemplatePatch!) {
  updateImpactGroupTemplate(input: {rowId: $rowId, patch: $patch}) {
    impactGroupTemplate {
      rowId
      label
      slug
      description
      notificationMessage
      severity
      scope
      location
      active
      actionUrl
      createdBy
      updatedBy
      templateExpiresAt
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateImpactGroupTemplateMutationFn = Apollo.MutationFunction<UpdateImpactGroupTemplateMutation, UpdateImpactGroupTemplateMutationVariables>;

/**
 * __useUpdateImpactGroupTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateImpactGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImpactGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImpactGroupTemplateMutation, { data, loading, error }] = useUpdateImpactGroupTemplateMutation({
 *   variables: {
 *      rowId: // value for 'rowId'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateImpactGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImpactGroupTemplateMutation, UpdateImpactGroupTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImpactGroupTemplateMutation, UpdateImpactGroupTemplateMutationVariables>(UpdateImpactGroupTemplateDocument, options);
      }
export type UpdateImpactGroupTemplateMutationHookResult = ReturnType<typeof useUpdateImpactGroupTemplateMutation>;
export type UpdateImpactGroupTemplateMutationResult = Apollo.MutationResult<UpdateImpactGroupTemplateMutation>;
export type UpdateImpactGroupTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateImpactGroupTemplateMutation, UpdateImpactGroupTemplateMutationVariables>;